import React from 'react';
import { Spin } from 'antd';

interface AsyncReceiptsProps {
	isDelinquent?: boolean;
	isCreditCardPaymentType?: boolean;
}

const LazyReceipts = React.lazy(() => import('./Receipts'));
export const AsyncReceiptsPage: React.FC<AsyncReceiptsProps> = ({
	isDelinquent,
	isCreditCardPaymentType,
}) => (
	<React.Suspense fallback={<Spin />}>
		<LazyReceipts
			isDelinquent={isDelinquent}
			isCreditCardPaymentType={isCreditCardPaymentType}
		/>
	</React.Suspense>
);
